<template>
	<div class="dashboard_container nunav_admin_dashboard" aria-label="Admin Dashboard Page Content">

		<div class="row">
	    <div class="col-12 dashboard-content-section">
	        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 pl-0 float-left">
	            <b-col cols="12 pl-0 pr-0 pg-lft-col">
	                <b-row class="dashboard-row">
	                    <b-col cols="12">
	                        <div class="card ace_sec" aria-label="All Courses Section">
	                            <div class="card-header">
	                                <span class="icon float-left icon-course text-center mr-2"></span>
	                                <span class="label ace_sec_hd" role="heading" aria-level="1">All Courses</span>
	                            </div>
	                            <div class="card-body carousel slide">
	                                <div class="carousel-inner">
	                                    <button class="button-primary fa fa-angle-left float-left" :disabled="page === 0" @click="prev" aria-label="previous"></button>
	                                    <div class="item active">
	                                        <template v-for="course in courses">
	                                            <div class="course ace_sec_txt" @click="navigateToCourseDashboard(course.uuid)" :aria-label="course.title">
	                                                <div class="course_name_container">
																										<div class="course_name_txt" :title="course.title" v-b-tooltip.hover.top>{{course.title}}</div>
																									</div>
	                                                <div class="thumbnail_container">
	                                                    <div class="icon-course">
	                                                  		<div class="icon-master" v-if="course.master">m</div>
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </template>
	                                    </div>
	                                    <button class="button-primary fa fa-angle-right float-right" :disabled="lastPage === true" @click="next" aria-label="next"></button>
	                                </div>
	                            </div>
	                        </div>
	                    </b-col>
	                </b-row>

	                <b-row class="dashboard-row btm-sec">
	                    <b-col cols="12" class="pg-lftbtm-col">
	                        <div class="card ace_sec" aria-label="Quick Links Section">
	                            <div class="card-header">
	                                <span class="icon float-left icon-link text-center mr-2"></span>
	                                <span class="label ace_sec_hd" role="heading" aria-level="1">Quick Links</span>
	                            </div>
	                            <div class="card-body">
	                                <div class="card-content v_scroll">
	                                    <div class="quick_link">
											<ul role="list">
												<li v-for="quickLink in quickLinks">
	                                            	<a :href="quickLink.url" target="_blank" :aria-label="'Link to ' + quickLink.title" tabindex="0" role="link">{{quickLink.title}}</a>
	                                            </li>
	                                        </ul>
	                                    </div>
	                                </div>
	                            </div>
	                        </div>
	                    </b-col>
	                </b-row>
	            </b-col>
	        </div>

	        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 pr-0 float-right">
	            <b-col cols="12" class="pr-0 pg-rgt-col">
	                <b-row class="dashboard-row">
	                    <b-col cols="12 pr-0">
	                        <div class="card ace_sec" aria-label="Recommendations Section">
	                            <div class="card-header">
	                                <span class="icon float-left icon-bullhorn text-center mr-2"></span>
	                                <span class="label ace_sec_hd" role="heading" aria-level="1">Recommendations</span>
	                            </div>
	                            <div class="card-body">
	                                <div class="card-content v_scroll">

	                                    <div class="recommendations">

	                                        <div class="coming_soon ace_sec_txt">Coming Soon</div>

	                                        <!--
	                                        <div class="row">
	                                            <div class="profile_pic">
	                                                <span class="icon icon-admin"></span>
	                                            </div>
	                                            <div class="details">
	                                                <div class="tp_row">
	                                                    <div class="title">Administrator</div>
	                                                    <div class="time">7:23 PM</div>
	                                                </div>
	                                                <div class="btm_row">
	                                                    Internship at Qualcom
	                                                </div>
	                                            </div>
	                                        </div>

	                                        <div class="row">
	                                            <div class="profile_pic">
	                                                <span class="icon icon-user"></span>
	                                            </div>
	                                            <div class="details">
	                                                <div class="tp_row">
	                                                    <div class="title">Prof. Whitman</div>
	                                                    <div class="time">7:43 PM</div>
	                                                </div>
	                                                <div class="btm_row">
	                                                    Internship at Illumina. There is only one space left.
	                                                </div>
	                                            </div>
	                                        </div>

	                                        <div class="row">
	                                            <div class="profile_pic">
	                                                <span class="icon icon-user"></span>
	                                            </div>
	                                            <div class="details">
	                                                <div class="tp_row">
	                                                    <div class="title">Prof. Kandinsky</div>
	                                                    <div class="time">6:18 PM</div>
	                                                </div>
	                                                <div class="btm_row">
	                                                    Veterna’s Center talk
	                                                </div>
	                                            </div>
	                                        </div>
	                                        -->
	                                        <!-- row end -->

	                                    </div> <!-- recommendations end -->

	                                </div> <!-- card-content end -->
	                            </div> <!-- card-body end -->
	                        </div> <!-- card end -->
	                    </b-col>
	                </b-row> <!-- dashboard-row end -->
	            </b-col>
	        </div>
	    </div>
		</div>

	</div>
</template>

<script>
  import '../../../assets/module/css/dashboard/dashboard.min.css'
  import { mapState, mapActions } from 'vuex'

  var staticQuickLinks = function () {
    var quickLinks = []
    return quickLinks
  }

  export default {
    name: 'admin-dashboard',
    props: [],
    data: () => {
      return {
        page: 0,
        courses: [],
        lastPage: false,
        quickLinks: []
      }
    },

    ready: function () {
      window.addEventListener('resize', this.populateOwnedCourses())
    },

    mounted () {
      this.loadQuickLinks().then(res => {
        const quickLinks = (this.links.length > 0) ? this.links : staticQuickLinks()
        $.each(quickLinks, (index, quickLink) => {
          this.quickLinks.push(quickLink)
        })
      })
      this.populateOwnedCourses()
      window.addEventListener('resize', this.handleWindowResize)
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadOwnedCourses'
      ]),

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'adminDashboard') {
          this.populateOwnedCourses()
        }
      },

      populateOwnedCourses () {
        var itemCount
        if ($(window).width() < 1501) {
          itemCount = 2
        } else {
          itemCount = 3
        }
        const pagingOptions = {page: this.page, count: itemCount}
        this.loadOwnedCourses(pagingOptions).then(res => {
          if (res) {
            this.courses = res.content
            this.lastPage = res.lastPage
          }
        })
      },

      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
      },

      prev () {
        this.page -= 1
        this.populateOwnedCourses()
      },

      next () {
        this.page += 1
        this.populateOwnedCourses()
      },

      navigateToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      }
    },

    computed: {
      ...mapState({
        'links': state => state.dashboard.quickLinks
      })
    }
  }
</script>

<style scoped>
    .next {
        margin-top: 10%;
    }

    .icon-master {
        float: right !important;
        margin-top: 0px !important;
        margin-left: 0px !important;
    }

    .slide-leave-active, .slide-enter-active {
        transition: 1s;
    }

    .slide-enter {
        transform: translate(100%, 0);
    }

    .slide-leave-to {
        transform: translate(-100%, 0);
    }

    .img-slider {
        overflow: hidden;
        position: relative;
        height: 200px;
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/NunavAdminDashboard.vue